import React from 'react';
import "./src/assets/ont-styleguide/styleguide.css";
// Bundle FontAwesome CSS statically so SSR markup is styled before hydration
// (otherwise icons render unconstrained/huge until FA injects its CSS at runtime).
import "@fortawesome/fontawesome-svg-core/styles.css";
import { config as faConfig } from "@fortawesome/fontawesome-svg-core";
faConfig.autoAddCss = false;
import Layout from './src/components/Layout';
export { wrapRootElement } from './src/apollo/wrap-root-element';
import * as ReactDOM from 'react-dom/client';
import { initHeapStubs, loadHeap } from './src/utils/heap';

export function wrapPageElement({ element, props }) {
    return <Layout {...props}>{element}</Layout>;
}

export function onClientEntry() {
    if (typeof window !== 'undefined') {
        window._hsq = window._hsq || [];
    }
    if (process.env.GATSBY_ENABLE_MAINTENANCE_MODE === 'true' && !window.location.pathname.includes('/maintenance')) {
        window.location = '/maintenance/';
    }
    initHeapStubs();
}

export function onRouteUpdate() {
    if (process.env.GATSBY_ENABLE_MAINTENANCE_MODE === 'true' && !window.location.pathname.includes('/maintenance')) {
        window.location = '/maintenance/';
    }
}

export function onInitialClientRender() {
    if (typeof window === 'undefined') return;
    function OptanonWrapper() { }

    const heapId = isProd() ? process.env.GATSBY_HEAP_PROD_ID : process.env.GATSBY_HEAP_TEST_ID;
    const idle = window.requestIdleCallback || (cb => setTimeout(cb, 1))
    idle(() => {
        loadHeap(heapId).catch(err => console.warn("Heap failed to load:", err));
    })
}

export const replaceHydrateFunction = () => {
    return (element, container) => {
        const root = ReactDOM.createRoot(container)
        root.render(element)
    }
}

function isProd() {
    const backendUrl = process.env.GATSBY_MAGENTO_BACKEND_URL;
    return backendUrl?.includes('//admin.store');
}
